import { ProjectColor, ProjectPalette } from "../api/Projects";

// The palette belongs to the server (see core/project/color.go), so the app and the
// morning digest email dress a project the same way. FeedProvider puts it here and
// PaletteGate holds back anything that draws with it until then, which is what lets
// every lookup below stay synchronous.
let palette: ProjectPalette | null = null;

export function setProjectPalette(value: ProjectPalette) {
    palette = value;
}

function loaded(): ProjectPalette {
    if (!palette) throw new Error("the project palette hasn't loaded yet");
    return palette;
}

// projectColors is the palette a project picks from, in the order it's shown in
export function projectColors(): ProjectColor[] {
    return loaded().colors;
}

// projectColorText is the body colour every tint is chosen to carry
export function projectColorText(): string {
    return loaded().text;
}

// findColor reads a stored colour key. A project saved before the palette had the
// key, or with none chosen, falls back to the first colour.
export function findColor(key: string | null | undefined): ProjectColor {
    return colorOrNull(key) || loaded().colors[0];
}

// randomColor gives a new project something to wear until someone picks for it
export function randomColor() {
    const colors = loaded().colors;
    return colors[Math.floor(Math.random() * colors.length)].key;
}

// neutralColor dresses a task that isn't filed under a project, for the places that
// have to draw every task in some colour
export function neutralColor(): ProjectColor {
    return loaded().neutral;
}

// colorOrNeutral is for the places that draw a task in its project's colour and fall
// back to the neutral tint rather than to a colour the task doesn't wear
export function colorOrNeutral(key: string | null | undefined): ProjectColor {
    return colorOrNull(key) || loaded().neutral;
}

// colorOrNull is for the places that only tint a task once it has a project, and
// leave it in the default styling otherwise
export function colorOrNull(key: string | null | undefined): ProjectColor | null {
    return loaded().colors.find(c => c.key === key) || null;
}
